import { Row, Col, Layout } from 'antd';
import PeersCommentsComponent from '../Organism/AddPeersCommentsComponent';
import AppHeaderHomePageTemplate from '../Organism/AppHeaderHomePageTemplate';
const { Content } = Layout;



const PeerComments: React.FC = () => {

  return (
    <Layout style={{ backgroundColor: 'white' }}>
        <AppHeaderHomePageTemplate/>
        <Content style={{ padding: '0 50px',backgroundColor: 'white' }}>
          <PeersCommentsComponent />
        </Content>
    </Layout>
  );
};

export default PeerComments;